<script lang="ts" setup>
import { computed, onMounted } from 'vue';
import { useLocalization } from '@/plugins/localization';
import { FormType } from '@/helpers/Form';
import { Option } from '@/helpers/Interfaces';

interface ItemModel {
    name: string;
    type: string;
}

export interface FormSettings {
    settings: {
        model: ItemModel[];
    };
}

defineOptions({
    name: 'widget-menu-mobile-settings',
});

const { $t } = useLocalization();

const typeOptions: Option<string>[] = [
    { value: 'InviteFriend', text: $t('[[[Zaproś znajomego]]]') },
    { value: 'Informations', text: $t('[[[Aktualności]]]') },
    { value: 'MyRewards', text: $t('[[[Moje nagrody]]]') },
    { value: 'Rankings', text: $t('[[[Rankingi]]]') },
    { value: 'PointsHistory', text: $t('[[[Historia punktów]]]') },
    { value: 'ArchivedTasks', text: $t('[[[Zadania archiwalne]]]') },
    { value: 'Help', text: $t('[[[Pomoc]]]') },
];

const model = defineModel<FormType<FormSettings>>();
const defaults: FormSettings['settings'] = {
    model: [],
};

const items = computed(() => model.value.settings?.model ?? []);

function typeLabel(type: string): string
{
    return typeOptions.find((p) => p.value === type)?.text ?? '';
}

function onAdd(): void
{
    const defaultType = typeOptions[0];

    items.value.push({ name: typeLabel(defaultType.value), type: defaultType.value });
}

function onDelete(index: number): void
{
    items.value.splice(index, 1);
}

function onTypeChange(item: ItemModel): void
{
    if (!item.name)
    {
        item.name = typeLabel(item.type);
    }
}

onMounted(async () =>
{
    model.value.settings = { ...defaults, ...model.value.settings };
});
</script>

<template>
    <div>
        <div v-if="items.length == 0" class="mb-2">
            <p class="text-center py-3 mb-0">
                {{ $t('[[[Nie ma jeszcze żadnych rekordów]]]') }}
            </p>
        </div>
        <div v-for="(item, index) in items" :key="index" class="d-flex gap-2 align-items-start mb-2">
            <ideo-form-group class="flex-grow-1 mb-0" :label="index == 0 ? $t('[[[Nazwa]]]') : null">
                <ideo-form-input v-model="item.name" type="text"></ideo-form-input>
            </ideo-form-group>
            <ideo-form-group class="flex-grow-1 mb-0" :label="index == 0 ? $t('[[[Typ]]]') : null">
                <ideo-form-select v-model="item.type" :options="typeOptions" @update:model-value="onTypeChange(item)" />
            </ideo-form-group>
            <ideo-button
                variant="light"
                icon="fas fa-trash-alt"
                :class="index == 0 ? 'mt-4' : ''"
                @click="onDelete(index)"
            ></ideo-button>
        </div>
        <ideo-button icon="fas fa-plus" @click="onAdd">
            {{ $t('[[[Dodaj]]]') }}
        </ideo-button>
    </div>
</template>
